export default __webpack_public_path__ + "static/media/Donate.3af7d8ba.svg";